import { render, staticRenderFns } from "./social-button.vue?vue&type=template&id=2893cd73&scoped=true&lang=pug&"
import script from "./social-button.vue?vue&type=script&lang=js&"
export * from "./social-button.vue?vue&type=script&lang=js&"
import style0 from "./social-button.vue?vue&type=style&index=0&id=2893cd73&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2893cd73",
  null
  
)

export default component.exports